import * as React from 'react';
import CirclePercentageBar from '../../../../elements/circular-percentage-bar';
import { jsx as _jsx } from "theme-ui/jsx-runtime";

var CircularPercentageBar = function CircularPercentageBar(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'xs' : _ref$size,
      percentage = _ref.percentage,
      _ref$align = _ref.align,
      align = _ref$align === void 0 ? 'start' : _ref$align;
  return _jsx(CirclePercentageBar, {
    size: size,
    percentage: percentage,
    align: align
  });
};

export default CircularPercentageBar;
//# sourceMappingURL=data-percentage.js.map